export const TABLE_REPORT_SLICE = 'TABLE_REPORT_SLICE';

export const TABLE_REPORT_URL_FIELD_NAME = 'ddUrlDto';
